import * as tslib_1 from "tslib";
import React from 'react';
import Popup from '../Popup';
import { ModalType } from './redux/types';
import CollectionPanel, { CollectionModal } from '../CollectionPanel';
import CommissionEditPopup from '../CommissionEditPopup';
import PostPopup from '../PostPopup';
import ErrorBoundary from '../ErrorBoundary';
import PollEditPopup from '../PollEditPopup';
import GivePopup from '../GivePopup';
import MyGroupsPopup from '../MyGroupsPopup';
import WriterPopup, { WriterPopupType } from '../WriterPopup';
import CommentModal from '../CommentModal';
import ConfirmationPopup from '../Popup/ConfirmationPopup';
import { SisuIframePopupSocial, SisuIframePopupWelcome, } from '../SisuIframePopup';
import { makeBadgeIframeSrc, makePointsIframeSrc, makeMyGroupsIframeSrc, makeDonatePointsIframeSrc, } from './helpers';
import VerificationPopup from '../VerificationPopup';
import BackgroundPickerPopup from '../DeviationBackground/BackgroundPickerPopup';
import ReportPopup from '../Moderation/ReportPopup';
import UserBlockPopup from '../Moderation/UserBlockPopup';
import { MobileDeviationSharePopup } from '../SharePopup';
import DeviationGroupListPopup from '../DeviationGroupListPopup';
import PcpPopup from '../PcpPopover/PcpPopup';
import OrderCommissionPopup from '../OrderCommissionPopup';
import AddToGroupsPanel from '../AddToGroupsPanel';
export var Modals = function (_a) {
    var children = _a.children, currentModal = _a.currentModal, currentUser = _a.currentUser, popModal = _a.popModal, disableAriaHide = _a.disableAriaHide;
    if (!currentModal) {
        return null;
    }
    var type = currentModal.type, _b = currentModal.options, params = _b.params, _c = _b.wrapInPopup, wrapInPopup = _c === void 0 ? true : _c, closeBtnClassName = _b.closeBtnClassName;
    var content;
    switch (type) {
        case ModalType.COLLECTION_MODAL:
            content = React.createElement(CollectionModal, tslib_1.__assign({}, params));
            break;
        case ModalType.STATUS_UPDATE:
            return React.createElement(PostPopup, tslib_1.__assign({ onClose: popModal }, params, { mode: "status" }));
        case ModalType.JOURNAL:
            return React.createElement(PostPopup, tslib_1.__assign({ onClose: popModal }, params, { mode: "journal" }));
        case ModalType.LITERATURE:
            return (React.createElement(WriterPopup, tslib_1.__assign({ onClose: popModal }, params, { type: WriterPopupType.LITERATURE })));
        case ModalType.COMMISSION:
            return React.createElement(CommissionEditPopup, tslib_1.__assign({ onClose: popModal }, params));
        case ModalType.POLL_EDIT:
            content = React.createElement(PollEditPopup, tslib_1.__assign({}, params));
            break;
        case ModalType.GIVE_BADGE:
            content = (React.createElement(GivePopup, { requestClose: popModal, title: params.title, iframeSrc: makeBadgeIframeSrc(params.badgeName, params.userId), onBadgeSent: params.onBadgeSent }));
            break;
        case ModalType.MY_GROUPS:
            if (!currentUser) {
                return null;
            }
            content = (React.createElement(MyGroupsPopup, { requestClose: popModal, title: params.title, iframeSrc: makeMyGroupsIframeSrc(currentUser.username) }));
            break;
        case ModalType.GIVE_POINTS:
            content = (React.createElement(GivePopup, { requestClose: popModal, title: params.title, height: 485, iframeSrc: makePointsIframeSrc(params.username) }));
            break;
        case ModalType.DONATE_POINTS:
            content = (React.createElement(GivePopup, { requestClose: popModal, title: params.title, height: 505, iframeSrc: makeDonatePointsIframeSrc(params.username, params.moduleId) }));
            break;
        case ModalType.SISU_SOCIAL:
            content = (React.createElement(SisuIframePopupSocial, { requestClose: popModal, authMode: params.authMode, token: params.token }));
            break;
        case ModalType.SISU_WELCOME:
            content = React.createElement(SisuIframePopupWelcome, { requestClose: popModal });
            break;
        case ModalType.COMMENT_THREAD:
            content = (React.createElement(CommentModal, { isOpen: true, requestClose: popModal, typeid: params.typeId, itemid: params.itemId, commentid: params.commentId, parentComment: params.parentComment }));
            break;
        case ModalType.CONFIRMATION:
            content = (React.createElement(ConfirmationPopup, { isOpen: true, title: params.title, text: params.text, icon: params.icon, cancelBtnLabel: params.cancelBtnLabel, confirmBtnLabel: params.confirmBtnLabel, confirmBtnType: params.confirmBtnType, onCancel: function () {
                    popModal();
                    params.onCancel && params.onCancel();
                }, onConfirm: function () {
                    popModal();
                    params.onConfirm && params.onConfirm();
                } }));
            break;
        case ModalType.VERIFICATION:
            content = (React.createElement(VerificationPopup, { actionType: params.actionType, onClose: popModal }));
            break;
        case ModalType.DEVIATION_BACKGROUND_PICKER:
            content = (React.createElement(BackgroundPickerPopup, { deviation: params.deviation, requestClose: popModal }));
            break;
        case ModalType.REPORT_DEVIATION:
            content = (React.createElement(ReportPopup, { reportUrl: params.reportUrl, deviationId: params.deviationId, requestClose: popModal }));
            break;
        case ModalType.USER_BLOCK:
            content = React.createElement(UserBlockPopup, { user: params.user, requestClose: popModal });
            break;
        case ModalType.MOBILE_COLLECTION_PANEL:
            content = React.createElement(CollectionPanel, { collectibleDeviation: params.deviation });
            break;
        case ModalType.MOBILE_GROUPS_PANEL:
            content = React.createElement(AddToGroupsPanel, { deviation: params.deviation });
            break;
        case ModalType.MOBILE_DEVIATION_SHARE:
            content = (React.createElement(MobileDeviationSharePopup, { deviation: params.deviation, requestClose: popModal }));
            break;
        case ModalType.DEVIATION_GROUP_LIST:
            content = (React.createElement(DeviationGroupListPopup, { title: params.title, url: params.url }));
            break;
        case ModalType.DEVIATION_PCP:
            content = (React.createElement(PcpPopup, { deviation: params.deviation, requestClose: popModal }));
            break;
        case ModalType.ORDER_COMMISSION:
            content = (React.createElement(OrderCommissionPopup, { deviation: params.deviation, requestClose: popModal }));
            break;
        default:
            if (!children) {
                return null;
            }
            content = (React.createElement(ErrorBoundary, null, children(type, popModal, params)));
    }
    if (!content) {
        return null;
    }
    if (!wrapInPopup) {
        return content;
    }
    return (React.createElement(Popup, { onRequestClose: popModal, withCloseButton: true, isOpen: true, width: "auto", height: "auto", disableAriaHide: disableAriaHide, closeBtnClassName: closeBtnClassName }, content));
};
Modals.displayName = 'Modals';
export default Modals;
//# sourceMappingURL=Modals.js.map